<template>
  <div class="is-fullwidth">
    <div class="is-clearfix">
      <nuxt-link
        class="button is-primary is-pulled-right"
        :to="localePath('office-users-create')"
      >{{ $t("form.create") }}</nuxt-link>

      <h1 class="is-size-3">{{ $t("page.users") }}</h1>
    </div>

    <pagination-control
      :controls="{ itemsPerPage, filter}"
      :pagination="$store.state.users.pagination"
    />

    <div class="table-wrapper" ref="tableWrapper">
      <table
        class="table m-t-5 is-striped is-fullwidth ws-nowrap"
        ref="table"
        v-if="$store.getters['users/listForTable'].length"
      >
        <thead>
          <tr>
            <th>
              <nuxt-link :to="{ query: querySort('first_name') }">
                {{ $t("form.name") }}
                <sort-icon sort-by="first_name" />
              </nuxt-link>
            </th>
            <th>
              <nuxt-link :to="{ query: querySort('city')}">
                {{ $t("form.city") }}
                <sort-icon sort-by="city" />
              </nuxt-link>
            </th>
            <th>
              <nuxt-link :to="{ query:querySort('company') }">
                {{ $t("form.company") }}
                <sort-icon sort-by="company" />
              </nuxt-link>
            </th>
            <th>
              <nuxt-link :to="{ query: querySort('active')}">
                {{ $t("form.active") }}
                <sort-icon sort-by="active" />
              </nuxt-link>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in $store.getters['users/listForTable']" :key="user.id">
            <th>
              <nuxt-link
                :to="
                  localePath({
                    name: 'office-users-id',
                    params: { id: user.id }
                  })
                "
              >{{ user.name }}</nuxt-link>
            </th>
            <td>{{ user.city }}</td>
            <td>{{ user.company }}</td>
            <td>{{ user.active ? $t('form.yes') : $t('form.no') }}</td>
          </tr>
        </tbody>
      </table>
      <div v-else>{{$t('message.no_data')}}</div>
    </div>
    <span
      v-if="showSwipeIcon"
      class="mdi mdi-gesture-swipe-horizontal has-text-primary"
      style="font-size: 25px"
    ></span>

    <pagination class="m-t-5" :meta="$store.state.users.pagination" />

    <nuxt-link
      v-if="$store.state.users.nru"
      :to="localePath({name: 'office-users-newly-registered'})"
      style="display: inline-block; margin: 50px 0;"
    >
      {{$t('form.newly_users')}}
      <span class="tag is-info">{{$store.state.users.nru}}</span>
    </nuxt-link>
    <span style="display: inline-block; margin: 50px 0;" v-else>
      {{$t('form.newly_users')}}
      <span class="tag is-info">{{$store.state.users.nru}}</span>
    </span>
  </div>
</template>

<script>
export default {
  watchQuery: true,

  async asyncData({ store, query, params }) {
    if (!params.skipReloding) {
      await store.dispatch("users/fetchUsers", query);
    }

    let objToReturn = {};

    if (query.per_page) {
      objToReturn.itemsPerPage = query.per_page;
    }

    objToReturn.filter = query.filter;

    return objToReturn;
  },

  computed: {
    showSwipeIcon() {
      return (
        this.isMounted &&
        this.$refs.table &&
        this.$refs.table.scrollWidth > this.$refs.tableWrapper.clientWidth
      );
    }
  }
};
</script>




// WEBPACK FOOTER //
// resources/nuxt/pages/office/users/index.vue